import React from 'react'

const Error = () => {
    return (
        <div>
            <p>
                La ruta que estás buscando es incorrecta. Por favor compruebala y vuelve a intentarlo.
            </p>
        </div>
    )
}

export default Error